import { ArrowLeft } from "lucide-react";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { ThemeToggle } from "../components/ThemeToggle";

export function NotFoundPage() {
  return <main className="not-found"><ThemeToggle className="not-found-theme-toggle" /><span>404</span><h1>这个页面不存在</h1><p>链接可能已失效，或者内容已经下架。</p><Button component={Link} variant="contained" startIcon={<ArrowLeft aria-hidden="true" />} to="/square">返回朋友圈</Button></main>;
}
